import type { Engine } from './engine';
import type { Camera } from '../render/camera';
import type { AudioEngine } from '../audio/audio';
import { PALETTE } from '../assets/palette';

/** 把引擎事件分发到音频 / 屏震 / 全屏闪光，随后清空事件队列。 */
export function drainEvents(
  engine: Engine, audio: AudioEngine, camera: Camera,
): void {
  for (const ev of engine.events) {
    audio.trigger(ev);
    if (ev.type === 'damage' || ev.type === 'explosion') {
      camera.addTrauma(ev.amount ?? 0);
    }
    const fl: [string, number] | null =
      ev.type === 'damage' ? [PALETTE.hp, 0.35 + (ev.amount ?? 0) / 120]
      : ev.type === 'levelup' ? [PALETTE.xp, 0.3]
      : ev.type === 'evolve' ? [PALETTE.terracotta, 0.55]
      : ev.type === 'shield_break' ? [PALETTE.shield, 0.4] : null;
    if (fl) camera.addFlash(fl[0], fl[1]);
  }
  engine.events.length = 0;
}
